import { apiBaseUrl } from './api';

const UUID = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

export const advertiserCoverUrl = id =>
  typeof id === 'string' && UUID.test(id) ? `/api/advertiser-covers/${id}` : null;

export const getAdvertiserCoverUrl = user =>
  advertiserCoverUrl(user?.attributes?.profile?.publicData?.advertiserCoverId);

// Normalize uploaded logos to a square canvas so wide marks are never cropped by avatar variants.
export const prepareBrandImage = async (file, logo = false) => {
  if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
    throw new Error('Choisissez une image JPG, PNG ou WebP.');
  }
  if (file.size > 10 * 1024 * 1024) throw new Error('Choisissez une image de moins de 10 Mo.');
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () =>
        reject(new Error('Cette image ne peut pas être lue. Essayez une autre photo.'));
      image.src = url;
    });
    const max = logo ? 800 : 1600;
    const scale = Math.min(1, max / Math.max(img.width, img.height));
    const width = Math.max(1, Math.round(img.width * scale));
    const height = Math.max(1, Math.round(img.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = logo ? Math.max(width, height) : width;
    canvas.height = logo ? canvas.width : height;
    const context = canvas.getContext('2d');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(img, (canvas.width - width) / 2, (canvas.height - height) / 2, width, height);
    for (const quality of [0.85, 0.7, 0.5, 0.3]) {
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
      if (blob && blob.size <= 409600)
        return new File([blob], logo ? 'logo.jpg' : 'couverture.jpg', { type: 'image/jpeg' });
    }
    throw new Error('Cette image est trop détaillée. Essayez une photo plus petite.');
  } finally {
    URL.revokeObjectURL(url);
  }
};

export const uploadAdvertiserCover = async file => {
  const response = await fetch(`${apiBaseUrl()}/api/advertiser-covers`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'image/jpeg', 'X-Cobuco-Request': 'dashboard' },
    body: file,
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Impossible d’importer la photo. Réessayez.');
  if (!advertiserCoverUrl(result.id)) throw new Error('Impossible d’importer la photo. Réessayez.');
  return result.id;
};
